import React from 'react';
import FPChip from 'UI/components/atoms/FPChip';

import { STEPS_STATUS_COLOR_BY_ID } from './BulkEmailSequenceStepStatusChip.constants';
import { useBulkEmailSequenceStepStatusChipStyles } from './BulkEmailSequenceStepStatusChip.styled';

export const BulkEmailSequenceStepStatusChip = ({ status }) => {
  const classes = useBulkEmailSequenceStepStatusChipStyles();

  return (
    <FPChip
      className={classes.statusChip}
      color={STEPS_STATUS_COLOR_BY_ID[status?.id] || STEPS_STATUS_COLOR_BY_ID.default}
      label={status?.title}
      variant="outlined"
    />
  );
};
